import { Box, Link, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function QrCodeDisplay({ imageData, targetUrl, testIdPrefix }) {
  const { t } = useTranslation();
  return (
    <Box sx={{ textAlign: "center", width: "100%" }}>
      <Stack direction="column" alignItems="center" justifyContent="center">
        <Typography variant="body1" color="text.secondary" fontWeight={300}>
          {t("PointYourCamera")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
            width: { xs: 260, sm: 360, md: 360 },
            height: { xs: 260, sm: 360, md: 360 },
          }}
        >
          {imageData && (
            <img
              src={imageData}
              alt={t("QrCodeImageAlt")}
              data-testid={testIdPrefix && `${testIdPrefix}.image`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
                borderRadius: "24px",
              }}
            />
          )}
        </Box>
        <Stack spacing={0.5} sx={{ px: 2, maxWidth: "100%" }}>
          <Typography
            variant="subtitle1"
            color="grayText"
            data-testid={testIdPrefix && `${testIdPrefix}.target-url`}
          >
            {targetUrl || "-"}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
